// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Yqbj","errorLogs":"EditorFooter_errorLogs__3W_yK"};